import { type FC } from 'react';
import { Box } from '@repo/ui/Box';
import { Text } from '../../components/Language/Language';
import { Step } from '../../components/Step/Step';
import {
  eligibleItemTaskId,
  headerContainer,
  headerId,
  itemSelectionStepId,
  subheaderId,
} from './baseConfig';
import s from './layout.module.css';
import { Layout } from '../../components/Layout/Layout';
import { useWorkflow } from '../../workflow/hooks';
import { Page } from '../../components/Page/Page';

export const ItemLayout: FC = () => {
  const { order } = useWorkflow();
  const { orderNumber, customer } = order ?? {};
  const replacementTokens = {
    order_number: orderNumber ?? '',
    first_name: customer?.firstName ?? '',
    last_name: customer?.lastName ?? '',
  };

  return (
    <Page>
      <Layout className={s?.[itemSelectionStepId]}>
        <Box padding={['px-24', 'md:px-0']}>
          <Box className={s[`${itemSelectionStepId}-${headerContainer}`]}>
            <h1 className={s[`${itemSelectionStepId}-${headerId}`]}>
              <Text
                langKey="pdx.item_selection.page_header"
                replacementTokens={replacementTokens}
              />
            </h1>
            <div className={s[`${itemSelectionStepId}-${subheaderId}`]}>
              <Text
                langKey="pdx.item_selection.page_description"
                replacementTokens={replacementTokens}
              />
            </div>
          </Box>
        </Box>
        <div className={s[`${itemSelectionStepId}-${eligibleItemTaskId}`]}>
          <Step formId={`${itemSelectionStepId}-${eligibleItemTaskId}`} />
        </div>
      </Layout>
    </Page>
  );
};
